// this is the model of the final transaction status
// 2021-08-19

export class FinalTxnStatus {
  amount: number;
  status: string;
  callbackUrl: string;
  currency: string;
  redirectUrl: string;
}
